import React from 'react'
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import TermsCard from '../termsCard/termsCard';
import Footer from '../Footer/Footer';

function Terms() {
  return (
    <div>
        <SideBar></SideBar>
        <TopBaner></TopBaner>
        <TermsCard></TermsCard>
        <Footer></Footer>
    </div>
  )
}

export default Terms